import LeaveDialogSection from "./LeaveDialogSection";
import { Calendar, CheckCircle, Clock, XCircle } from "lucide-react";

const LeavesSection = ({ ctx }) => {
  const {
    canApproveLeaves,
    getStatusBadge,
    handleRejectLeave,
    leaves,
    openLeaveApprovalDialog,
    setStatusFilter,
    statusFilter
  } = ctx;
  return (
    <>
        <div>
          {/* Actions Bar */}
          <div className="flex justify-between mb-6">
            <div className="flex space-x-2">
              <button
                onClick={() => setStatusFilter("")}
                className={`px-4 py-2 rounded-sm text-sm font-medium transition-colors ${
                  statusFilter === "" ? "bg-primary text-white" : "bg-slate-100 text-slate-600 hover:bg-slate-200"
                }`}
              >
                All
              </button>
              <button
                onClick={() => setStatusFilter("Pending")}
                className={`px-4 py-2 rounded-sm text-sm font-medium transition-colors ${
                  statusFilter === "Pending" ? "bg-warning text-white" : "bg-slate-100 text-slate-600 hover:bg-slate-200"
                }`}
              >
                Pending ({leaves.filter(l => l.status === "Pending").length})
              </button>
              <button
                onClick={() => setStatusFilter("Approved")}
                className={`px-4 py-2 rounded-sm text-sm font-medium transition-colors ${
                  statusFilter === "Approved" ? "bg-success text-white" : "bg-slate-100 text-slate-600 hover:bg-slate-200"
                }`}
              >
                Approved
              </button>
              <button
                onClick={() => setStatusFilter("Rejected")}
                className={`px-4 py-2 rounded-sm text-sm font-medium transition-colors ${
                  statusFilter === "Rejected" ? "bg-error text-white" : "bg-slate-100 text-slate-600 hover:bg-slate-200"
                }`}
              >
                Rejected
              </button>
            </div>

            <LeaveDialogSection ctx={ctx} />
          </div>

          {/* Leaves List */}
          <div className="space-y-4">
            {leaves
              .filter(l => !statusFilter || l.status === statusFilter)
              .map((leave) => (
              <div key={leave.id} className={`stat-card ${leave.status === "Rejected" ? "border-l-4 border-l-error" : leave.status === "Approved" ? "border-l-4 border-l-success" : leave.is_urgent ? "border-l-4 border-l-warning" : ""}`} data-testid={`leave-entry-${leave.id}`}>
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <div className="flex items-center space-x-3 mb-2">
                      <h3 className="font-heading font-bold text-lg text-primary">{leave.employee_name}</h3>
                      <span className="font-mono text-xs text-slate-500">{leave.employee_code}</span>
                      {getStatusBadge(leave.status)}
                      {leave.is_urgent && leave.status === "Pending" && (
                        <span className="px-2 py-0.5 rounded-sm text-xs font-bold bg-warning/20 text-warning flex items-center space-x-1">
                          <Clock className="w-3 h-3" />
                          <span>URGENT</span>
                        </span>
                      )}
                    </div>
                    <div className="grid grid-cols-4 gap-4 text-sm mb-3">
                      <div>
                        <p className="text-xs uppercase tracking-widest text-slate-600 mb-1">Leave Type</p>
                        <p className="font-medium">{leave.leave_type}</p>
                      </div>
                      <div>
                        <p className="text-xs uppercase tracking-widest text-slate-600 mb-1">From</p>
                        <p className="font-mono">{leave.start_date}</p>
                      </div>
                      <div>
                        <p className="text-xs uppercase tracking-widest text-slate-600 mb-1">To</p>
                        <p className="font-mono">{leave.end_date}</p>
                      </div>
                      <div>
                        <p className="text-xs uppercase tracking-widest text-slate-600 mb-1">Days</p>
                        <p className="font-mono font-bold text-primary">{leave.days_count}</p>
                      </div>
                    </div>
                    <p className="text-sm text-slate-600"><strong>Reason:</strong> {leave.reason}</p>
                    {leave.status === "Rejected" && leave.rejection_reason && (
                      <p className="text-sm text-error mt-2 bg-error/10 px-2 py-1 rounded-sm">
                        <strong>Rejection reason:</strong> {leave.rejection_reason}
                      </p>
                    )}
                    {leave.status === "Approved" && (
                      <p className="text-sm text-success mt-2">
                        Approved by {leave.approved_by_name} on {leave.approved_at?.split('T')[0]}
                      </p>
                    )}
                  </div>
                  
                  {/* Action Buttons */}
                  {leave.status === "Pending" && canApproveLeaves && (
                    <div className="flex items-center space-x-2 ml-4">
                      <button
                        onClick={() => openLeaveApprovalDialog(leave)}
                        data-testid={`approve-leave-${leave.id}`}
                        className="btn-primary flex items-center space-x-1 text-sm px-3 py-1 bg-success hover:bg-success/90"
                      >
                        <CheckCircle className="w-4 h-4" />
                        <span>Approve</span>
                      </button>
                      <button
                        onClick={() => handleRejectLeave(leave.id)}
                        data-testid={`reject-leave-${leave.id}`}
                        className="btn-outline flex items-center space-x-1 text-sm px-3 py-1 border-error text-error hover:bg-error/10"
                      >
                        <XCircle className="w-4 h-4" />
                        <span>Reject</span>
                      </button>
                    </div>
                  )}
                </div>
              </div>
            ))}
            
            {leaves.filter(l => !statusFilter || l.status === statusFilter).length === 0 && (
              <div className="text-center py-16 stat-card">
                <Calendar className="w-16 h-16 mx-auto mb-4 text-slate-400" />
                <h3 className="font-heading font-bold text-xl mb-2">No Leave Requests</h3>
                <p className="text-slate-600">
                  {statusFilter ? `No ${statusFilter.toLowerCase()} leave requests found.` : "No leave requests have been submitted yet."}
                </p>
              </div>
            )}
          </div>
        </div>
    </>
  );
};

export default LeavesSection;
